import React, { useEffect, useState } from 'react'
import { Suspense } from 'react'
import withMenuSingle from '../../hoc/withMenuSingle'
import useInterval from '../../hoc/useInterval'
import general from '../../helpers/general'
import IncomingMenus from '../Alerts/IncomingMenus'
import withSelectedMenu from '../../hoc/withSelectedMenu'
import { useHistory, useLocation } from 'react-router-dom'
import { buildMenuSearch, getMenuQuery } from '../../helpers/navigation'

function SingleMenuWrapper(props) {
	const { restaurant } = props
	const history = useHistory()
	const location = useLocation()

	const delay = 30000
	const interval = useInterval(checkClosestMenu, delay)

	const [DishLazyLoadedTemplate, setDishLazyLoadedTemplate] = useState(null)
	const [notifyMenus, setNotifyMenus] = useState(null)

	function checkClosestMenu() {
		const notifyMenus = general?.findClosestMenus(
			props?.menusTimeline,
			restaurant?.menus,
			restaurant?.menu_period_transition,
		)
		if (notifyMenus?.length > 0) {
			interval?.reset()
			setNotifyMenus(notifyMenus)
		}
	}

	useEffect(() => {
		let template = 'Classic Template'
		if (props?.menu?.selectedTemplate && props?.menu?.selectedTemplate !== 'undefined') {
			template = props?.menu?.selectedTemplate
		}
		setDishLazyLoadedTemplate(React.lazy(() => import(`../../Templates/${template}/SingleMenuPage`)))
		// eslint-disable-next-line
	}, [])

	const onCloseIncomingMenu = () => {
		setNotifyMenus([])
		interval?.start()
	}

	const onSwitchIncomingMenu = async () => {
		const { dmaId } = getMenuQuery(location?.search)
		const menuId = notifyMenus?.length === 1 ? notifyMenus?.[0]?._id : null
		history.push({
			pathname: `/menu/${restaurant?._id}`,
			search: buildMenuSearch({ menuId, dmaId }),
		})
		setNotifyMenus([])
	}

	return (
		<>
			{DishLazyLoadedTemplate && (
				<>
					{notifyMenus && notifyMenus?.length > 0 && (
						<IncomingMenus
							menus={notifyMenus}
							minutes={restaurant?.menu_period_transition}
							onClose={onCloseIncomingMenu}
							onSwitch={onSwitchIncomingMenu}
							currentMenu={props?.menu}
						/>
					)}
					<Suspense fallback={<></>}>
						<DishLazyLoadedTemplate {...props} />
					</Suspense>
				</>
			)}
		</>
	)
}

export default withMenuSingle(withSelectedMenu(SingleMenuWrapper))
